export default __webpack_public_path__ + "static/media/warning--kiwi-crossing--g2.31b4982f.png";